import React, { useState } from 'react';
import { SearchIcon, PaperclipIcon, SendIcon, SmileIcon, PlusIcon, ImageIcon, FileIcon, MapPinIcon } from 'lucide-react';
// Mock conversation data
const mockConversations = [{
  id: 1,
  name: 'BoxMaster Inc.',
  avatar: 'B',
  lastMessage: 'Yes, we can customize the boxes with your logo.',
  timestamp: '10:23 AM',
  unread: 2,
  online: true
}, {
  id: 2,
  name: 'Green Packaging Co.',
  avatar: 'G',
  lastMessage: 'The minimum order quantity is 1,000 units.',
  timestamp: 'Yesterday',
  unread: 0,
  online: false
}, {
  id: 3,
  name: 'BrandPack Solutions',
  avatar: 'B',
  lastMessage: "We've sent you a quote for the custom printed tape.",
  timestamp: 'Tuesday',
  unread: 0,
  online: true
}, {
  id: 4,
  name: 'SafePack Inc.',
  avatar: 'S',
  lastMessage: 'The bubble wrap rolls are available in three sizes.',
  timestamp: 'Monday',
  unread: 0,
  online: false
}, {
  id: 5,
  name: 'Retail Packaging Co.',
  avatar: 'R',
  lastMessage: 'Would you like to see samples before placing an order?',
  timestamp: 'Last week',
  unread: 0,
  online: false
}];
// Mock messages for the active conversation
const mockMessages = [{
  id: 1,
  sender: 'BoxMaster Inc.',
  content: 'Hello! How can I help you today?',
  timestamp: '10:05 AM',
  isMe: false
}, {
  id: 2,
  sender: 'Me',
  content: "Hi, I'm interested in your corrugated boxes. Can you tell me more about the customization options?",
  timestamp: '10:07 AM',
  isMe: true
}, {
  id: 3,
  sender: 'BoxMaster Inc.',
  content: "Of course! We offer full color printing on all sides of our boxes. You can add your logo, brand colors, and any other design elements you'd like.",
  timestamp: '10:10 AM',
  isMe: false
}, {
  id: 4,
  sender: 'BoxMaster Inc.',
  content: 'We also offer different finishes like matte, glossy, or soft-touch coating.',
  timestamp: '10:11 AM',
  isMe: false
}, {
  id: 5,
  sender: 'Me',
  content: "That sounds great! What's the minimum order quantity for custom printed boxes?",
  timestamp: '10:15 AM',
  isMe: true
}, {
  id: 6,
  sender: 'BoxMaster Inc.',
  content: 'Our minimum order for custom printed boxes is 500 units. For larger orders, we offer volume discounts.',
  timestamp: '10:18 AM',
  isMe: false
}, {
  id: 7,
  sender: 'Me',
  content: 'Perfect. Can you also add our logo to the boxes?',
  timestamp: '10:20 AM',
  isMe: true
}, {
  id: 8,
  sender: 'BoxMaster Inc.',
  content: 'Yes, we can customize the boxes with your logo. Could you send us the logo file in vector format (AI, EPS, or PDF) for the best results?',
  timestamp: '10:23 AM',
  isMe: false
}];
export function Messages() {
  const [activeConversation, setActiveConversation] = useState(mockConversations[0]);
  const [message, setMessage] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  // Filter conversations based on search query
  const filteredConversations = mockConversations.filter(conversation => conversation.name.toLowerCase().includes(searchQuery.toLowerCase()));
  const handleSendMessage = e => {
    e.preventDefault();
    if (message.trim()) {
      // In a real app, this would send the message to the API
      console.log('Sending message:', message);
      setMessage('');
    }
  };
  return <div className="bg-white rounded-lg shadow overflow-hidden h-[calc(100vh-12rem)]" data-id="element-329">
      <div className="flex h-full" data-id="element-330">
        {/* Conversation List */}
        <div className="w-full sm:w-80 border-r border-gray-200 flex flex-col" data-id="element-331">
          <div className="p-4 border-b border-gray-200" data-id="element-332">
            <div className="relative" data-id="element-333">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-334">
                <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-335" />
              </div>
              <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="Search messages..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-336" />
            </div>
          </div>
          <div className="flex-1 overflow-y-auto" data-id="element-337">
            {filteredConversations.map(conversation => <button key={conversation.id} className={`w-full text-left px-4 py-3 border-b border-gray-200 hover:bg-gray-50 focus:outline-none ${activeConversation.id === conversation.id ? 'bg-blue-50' : ''}`} onClick={() => setActiveConversation(conversation)} data-id="element-338">
                <div className="flex items-center" data-id="element-339">
                  <div className="relative" data-id="element-340">
                    <div className={`h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-800 font-medium`} data-id="element-341">
                      {conversation.avatar}
                    </div>
                    {conversation.online && <span className="absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full bg-green-400 ring-2 ring-white" data-id="element-342"></span>}
                  </div>
                  <div className="ml-3 flex-1 min-w-0" data-id="element-343">
                    <div className="flex items-center justify-between" data-id="element-344">
                      <p className={`text-sm font-medium ${conversation.unread ? 'text-gray-900' : 'text-gray-700'} truncate`} data-id="element-345">
                        {conversation.name}
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-346">
                        {conversation.timestamp}
                      </p>
                    </div>
                    <div className="flex items-center justify-between" data-id="element-347">
                      <p className={`text-sm ${conversation.unread ? 'font-medium text-gray-900' : 'text-gray-500'} truncate`} data-id="element-348">
                        {conversation.lastMessage}
                      </p>
                      {conversation.unread > 0 && <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-349">
                          {conversation.unread}
                        </span>}
                    </div>
                  </div>
                </div>
              </button>)}
          </div>
        </div>
        {/* Conversation */}
        <div className="hidden sm:flex flex-col flex-1" data-id="element-350">
          {activeConversation ? <>
              {/* Conversation Header */}
              <div className="flex items-center justify-between p-4 border-b border-gray-200" data-id="element-351">
                <div className="flex items-center" data-id="element-352">
                  <div className="relative" data-id="element-353">
                    <div className={`h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-800 font-medium`} data-id="element-354">
                      {activeConversation.avatar}
                    </div>
                    {activeConversation.online && <span className="absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full bg-green-400 ring-2 ring-white" data-id="element-355"></span>}
                  </div>
                  <div className="ml-3" data-id="element-356">
                    <p className="text-sm font-medium text-gray-900" data-id="element-357">
                      {activeConversation.name}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-358">
                      {activeConversation.online ? 'Online' : 'Offline'}
                    </p>
                  </div>
                </div>
                <div className="flex items-center space-x-2" data-id="element-359">
                  <button className="p-2 rounded-full text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-360">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-361">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" data-id="element-362" />
                    </svg>
                  </button>
                  <button className="p-2 rounded-full text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-363">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-364">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" data-id="element-365" />
                    </svg>
                  </button>
                  <button className="p-2 rounded-full text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-366">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-367">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" data-id="element-368" />
                    </svg>
                  </button>
                </div>
              </div>
              {/* Messages */}
              <div className="flex-1 p-4 overflow-y-auto" data-id="element-369">
                <div className="space-y-4" data-id="element-370">
                  {mockMessages.map(msg => <div key={msg.id} className={`flex ${msg.isMe ? 'justify-end' : 'justify-start'}`} data-id="element-371">
                      {!msg.isMe && <div className="flex-shrink-0 mr-3" data-id="element-372">
                          <div className={`h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-800 text-sm font-medium`} data-id="element-373">
                            {activeConversation.avatar}
                          </div>
                        </div>}
                      <div className={`rounded-lg px-4 py-2 max-w-xs lg:max-w-md ${msg.isMe ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-800'}`} data-id="element-374">
                        <p className="text-sm" data-id="element-375">{msg.content}</p>
                        <p className={`text-xs mt-1 ${msg.isMe ? 'text-blue-200' : 'text-gray-500'}`} data-id="element-376">
                          {msg.timestamp}
                        </p>
                      </div>
                      {msg.isMe && <div className="flex-shrink-0 ml-3" data-id="element-377">
                          <div className={`h-8 w-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-sm font-medium`} data-id="element-378">
                            M
                          </div>
                        </div>}
                    </div>)}
                </div>
              </div>
              {/* Message Input */}
              <div className="p-4 border-t border-gray-200" data-id="element-379">
                <form onSubmit={handleSendMessage} className="flex items-center" data-id="element-380">
                  <button type="button" className="p-2 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-381">
                    <PlusIcon className="h-5 w-5" data-id="element-382" />
                  </button>
                  <div className="relative flex-1 mx-2" data-id="element-383">
                    <input type="text" className="block w-full py-2 px-4 border border-gray-300 rounded-full leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="Type a message..." value={message} onChange={e => setMessage(e.target.value)} data-id="element-384" />
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3" data-id="element-385">
                      <button type="button" className="text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-386">
                        <SmileIcon className="h-5 w-5" data-id="element-387" />
                      </button>
                    </div>
                  </div>
                  <button type="button" className="p-2 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-388">
                    <PaperclipIcon className="h-5 w-5" data-id="element-389" />
                  </button>
                  <button type="submit" className="ml-2 p-2 rounded-full bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-390">
                    <SendIcon className="h-5 w-5" data-id="element-391" />
                  </button>
                </form>
                <div className="mt-2 flex justify-center" data-id="element-392">
                  <div className="flex space-x-2" data-id="element-393">
                    <button className="p-1 rounded text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none" data-id="element-394">
                      <ImageIcon className="h-4 w-4" data-id="element-395" />
                    </button>
                    <button className="p-1 rounded text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none" data-id="element-396">
                      <FileIcon className="h-4 w-4" data-id="element-397" />
                    </button>
                    <button className="p-1 rounded text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none" data-id="element-398">
                      <MapPinIcon className="h-4 w-4" data-id="element-399" />
                    </button>
                  </div>
                </div>
              </div>
            </> : <div className="flex-1 flex items-center justify-center" data-id="element-400">
              <div className="text-center" data-id="element-401">
                <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-402">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" data-id="element-403" />
                </svg>
                <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-404">
                  No conversation selected
                </h3>
                <p className="mt-1 text-sm text-gray-500" data-id="element-405">
                  Select a conversation to start messaging.
                </p>
              </div>
            </div>}
        </div>
        {/* Mobile: No conversation selected message */}
        <div className="sm:hidden flex-1 flex items-center justify-center" data-id="element-406">
          <div className="text-center" data-id="element-407">
            <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-408">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" data-id="element-409" />
            </svg>
            <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-410">
              Your Messages
            </h3>
            <p className="mt-1 text-sm text-gray-500" data-id="element-411">
              Select a conversation from the list to view messages.
            </p>
          </div>
        </div>
      </div>
    </div>;
}